"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformChildSeatToAgeAndWeightString = transformChildSeatToAgeAndWeightString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformChildSeatToAgeAndWeightString(childSeatType) {
    switch (childSeatType) {
        case legacy_enums_1.ChildSeatType.Booster:
            return "6-12y, 44-72 lbs";
        case legacy_enums_1.ChildSeatType.BoosterSeat:
            return "4-6y, 30-50 lbs";
        case legacy_enums_1.ChildSeatType.ForwardFacing:
            return "1-4y, 18-36 lbs";
        case legacy_enums_1.ChildSeatType.RearFacing:
            return "0-1y, 0-26 lbs";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformChildSeatToAgeAndWeightString.js.map